import { Injectable, inject } from '@angular/core';
import { BaseApiService } from '@bo/ng-api';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FaqCategory, Faq } from '../../_interfaces/faq.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FaqApiService extends BaseApiService {
  protected override http: HttpClient;

  override baseUrl: string = environment.apiRoot;
  URL_FAQ: string = 'faq';
  URL_FAQ_CATEGORIES: string = 'faq/categories';

  constructor() {
    const http = inject(HttpClient);

    super(http);

    this.http = http;
  }

  getFaqDetails(tagSlug?: string, categorySlug?: string): Observable<Faq[]> {
    let params = new HttpParams();
    if (tagSlug) params = params.set('tags__slug', tagSlug);
    if (categorySlug) params = params.set('category__slug', categorySlug);
    return this.http.get<Faq[]>(this.getUrl(this.URL_FAQ, true), { params });
  }

  getFaqCategories(): Observable<FaqCategory[]> {
    return this.http.get<FaqCategory[]>(this.getUrl(this.URL_FAQ_CATEGORIES, true));
  }
}
